import React, {useState, memo, useCallback, useEffect, forwardRef, useImperativeHandle} from "../../__snowpack__/pkg/react.js";
import {Modal, Form, message} from "../../__snowpack__/pkg/antd.js";
import {axios} from "../lib/axios.js";
import renderFormItems from "../assets/utils/render-form-items/index.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
export const FormModal = memo(forwardRef((props, ref) => {
  const [isBthLoading, setIsBthLoading] = useState(false);
  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    resetFields: (keys) => {
      keys && form.resetFields(keys);
      if (!keys) {
        form.resetFields();
      }
    }
  }));
  const handleOk = useCallback(async () => {
    try {
      form.validateFields().then((values) => {
        props.onHanleOkCallback && props.onHanleOkCallback(values);
        if (!props.apiUrl)
          return;
        setIsBthLoading(true);
        let params = {
          ...props.apiParam,
          ...values
        };
        let apiMethod = props.apiMethod || "get";
        let queryPromise;
        if (props.formatParam) {
          params = props.formatParam(params);
        }
        if (apiMethod === "get") {
          queryPromise = axios[apiMethod](props.apiUrl, {
            params
          });
        } else {
          queryPromise = axios[apiMethod](props.apiUrl, params);
        }
        queryPromise.then((data) => {
          setIsBthLoading(false);
          if (data.code === "SUCCESS") {
            message.success(props.successTips || data.message);
            props.onHanleSuccessCallback && props.onHanleSuccessCallback();
            form.resetFields();
          } else {
            message.error(data.message);
            props.onHanleFailCallback && props.onHanleFailCallback();
          }
        }).catch((errorInfo) => {
          message.error(errorInfo.toString());
        });
      });
    } catch (error) {
      message.error(error?.toString());
    }
  }, [props.apiUrl]);
  useEffect(() => {
    props.onHandleEffect && props.onHandleEffect(form);
    !props.saveFormField && props.modalVisible && form.resetFields();
  }, [props.modalVisible]);
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Modal, {
    title: props.title,
    visible: props.modalVisible,
    onOk: handleOk,
    confirmLoading: isBthLoading,
    onCancel: () => {
      props.onHanleCancelCallback && props.onHanleCancelCallback();
    },
    ...props.otherProps
  }, /* @__PURE__ */ React.createElement(Form, {
    layout: props.formLayout || "vertical",
    form
  }, props.formItems && props.formItems.length && renderFormItems(props.formItems, form))));
}));
const Wrapper = styled.div`
  background-color: #fff;
`;
